import iconVideo from 'assets/img/icon/video.png';
import iconMicrophone from 'assets/img/icon/microphone.png';
import iconCamera from 'assets/img/icon/camera.png';
import iconVoice from 'assets/img/icon/voice.png';
import iconIsProgressing from 'assets/img/isprogressing.gif';

import React from 'react';
import Page from 'components/Page';
import {
	Button,
	ButtonGroup,
	Card,
	CardBody,
	CardHeader,
	Col,
	Form,
	FormFeedback,
	FormGroup,
	FormText,
	Input,
	Label,
	Row,
	Modal, ModalBody, ModalFooter, ModalHeader
  } from 'reactstrap';
  import Base64 from 'Base64';
  import { Cookies } from 'react-cookie';
  import ComboBox from './component/ComboBox.js';
  import NotificationSystem from 'react-notification-system';
  import { NOTIFICATION_SYSTEM_STYLE } from 'utils/constants';
  import Drive from './ViewDrive/Drive.js';
  import DataAdapter from "./adapter/DataAdapter";
import DateTime from './lib/DateTime.js';
import MessageUtil from './lib/MessageUtil.js';
  

  const cookie =new Cookies();
  
  
class QuickFormTask extends React.Component {
	notificationSystem = React.createRef();
	constructor(props){
		super(props);
		this.state = 			{
			inProgress			:	false,
			project				:	0,
			board				:	0,
			folder				:	'',
			tasksFolder			:	'',
			taskFolder			:	'',
			board_type			:	0,
			sender_id			:	cookie.get("v-person-id"),
			receiver_id			:	-1,
			receiver_email		:	'',
			task 				:	'',
			task_status			:	8,
			task_type			:	92,
			expected_end_date	:	(new DateTime()).getToday(),
			image				:	null,
			video				:	null,
			videoBlob			:	null,
			preview 			:	false,
			recognitionLang: 'fa-IR', // or 'en-US'
		};
	}
	resetStates=()=>{
		this.setState(
			{
				inProgress			:	false,
				project				:	0,
				board				:	0,
				folder				:	'',
				tasksFolder			:	'',
				taskFolder			:	'',
				board_type			:	0,
				sender_id			:	cookie.get("v-person-id"),
				receiver_id			:	-1,
				receiver_email		:	'',
				task 				:	'',
				task_status			:	8,
				task_type			:	92,
				expected_end_date	:	(new DateTime()).getToday(),
				image				:	null,
				video				:	null,
				videoBlob			:	null,
				preview 			:	false,
			}
		)
	}
	addNotification(_MESSAGE_) {
		const notification = this.notificationSystem.current;
		notification.addNotification({
			message: _MESSAGE_,
			level: 'success'
		});
	};

	handleVoiceInput = (e) =>{
		const recognition = new window.webkitSpeechRecognition();
		recognition.lang = this.state.recognitionLang;
		recognition.interimResults = false;
		recognition.maxAlternatives = 1;
	
		recognition.start();
	
		recognition.onresult = (event) => {
		  const speechResult = event.results[0][0].transcript;
		  console.log(speechResult);
		  this.setState({task: speechResult});
		};
	
		recognition.onerror = (event) => {
		  console.error('Speech recognition error', event.error);
		};

	}

	runQuery = (query, message) => {
		let formData = new FormData();
		formData.append("query", query);
		let requestOptions = { method: 'POST', headers: { 'Authorization': 'Basic ' + Base64.btoa('sizotech:IsKfs$m$SZV#4Eprtj7zSPbO') }, body: formData };
		fetch('https://renobuilding.ca/wp-json/reno/v1/query/', requestOptions)
			.then(response => {
				return Promise.all([response.json(), response])
			})
			.then(([responseData, response]) => {
				this.addNotification(message, "success");

			})
			.catch(error => {
				console.error('Error:', error);
			})
	}
	
	onSubmitHandler = async (e) =>{
		this.setState({inProgress : true});
		const _query    =   "INSERT INTO rb_project_tasks (prj_id, sender_id, receiver_id, task, task_status, task_type, start_date, expected_end_date, create_date) values (" + this.state.project + ", " + this.state.sender_id + "," + this.state.receiver_id + ",'" + this.state.task + "'," + this.state.task_status + "," + this.state.task_type + ",now(),'" + this.state.expected_end_date + "',now());\r\nSELECT * FROM rb_project_tasks ORDER BY pt_id DESC LIMIT 1;";
        var dataAdapter =new DataAdapter(_query);
        var data = await dataAdapter.getRecords();
		const emailBody = `
					<!doctype html>
					<html lang="en">
					<head>
					<meta charset="utf-8">
					<meta name="viewport" content="width=device-width,initial-scale=1">
					<title>New Task Assigned</title>
					</head>
					<body style="margin:0;padding:0;background-color:#f7f6f4;font-family:Arial, Helvetica, sans-serif;">
					<table role="presentation" cellpadding="0" cellspacing="0" width="100%" style="max-width:600px;margin:30px auto;background:#ffffff;border-radius:8px;overflow:hidden;box-shadow:0 2px 6px rgba(0,0,0,0.08);">
						
						<!-- Title Bar -->
						<tr>
						<td style="padding:14px 24px;background:#c9a34f;text-align:center;color:#000000;">
							<h1 style="margin:0;font-size:18px;font-weight:600;">New Task Assigned</h1>
						</td>
						</tr>

						<!-- Body -->
						<tr>
						<td style="padding:24px;">
							<p style="margin:0 0 12px 0;font-size:15px;color:#222222;">Hi <strong></strong>,</p>

							<p style="margin:0 0 16px 0;font-size:15px;color:#222222;">
							You have been assigned a new task:
							</p>

							<p style="margin:0 0 20px 0;font-size:16px;color:#000000;font-weight:700;">
							${this.state.task}
							</p>

							<p style="margin:0 0 20px 0;text-align:center;">
							<a href="https://app.8co.ca/" style="display:inline-block;padding:10px 20px;text-decoration:none;border-radius:6px;background:#000000;color:#c9a34f;font-weight:600;">
								View Task
							</a>
							</p>

							<p style="margin:0 0 10px 0;font-size:14px;color:#555555;">
							Please review the task details and start when ready. If you have any questions or need clarification, contact your manager.
							</p>

							<p style="margin:22px 0 0 0;font-size:14px;color:#555555;">
							Best regards,<br>
							<strong>Office Manager</strong><br>
							<span style="color:#777777;font-size:13px;">8CO Group</span>
							</p>
						</td>
						</tr>

						<!-- Footer -->
						<tr>
						<td style="padding:14px 24px;background:#000000;color:#c9a34f;font-size:12px;text-align:center;">
							You are receiving this because a task was assigned to you. If this is an error, please contact your administrator.
						</td>
						</tr>
					</table>
					</body>
					</html>
		`;
		(new MessageUtil()).onSendEmail("office@8cogroup.com", this.state.receiver_email, "8CO - Task Assignment Notification", emailBody, "Office@2025!ecogroup");
		var folderName	= data[0].pt_id + ' - ' + data[0].task;
		(new Drive()).createFolder(this.state.tasksFolder, folderName)
		.then(response=>{
			this.setState({taskFolder : response});
			const _query    =   "UPDATE rb_project_tasks SET attachments='" + response + "' WHERE pt_id=" + data[0].pt_id;
			var dataAdapter =new DataAdapter(_query);
				dataAdapter.getRecords().then(()=>{
					if(this.state.image || this.state.video || this.state.audio){
						this.fileUpload(data[0].pt_id);
					}
					this.setState({task : '', inProgress : false});
					this.addNotification("The task is assigned successfully");				
				});
		});
		//this.runQuery("INSERT INTO rb_project_tasks (prj_id, sender_id, receiver_id, task, task_status, task_type, start_date, expected_end_date, create_date) values (" + this.state.prj_id + ", " + this.state.sender_id + "," + this.state.receiver_id + ",'" + this.state.task + "'," + this.state.task_status + "," + this.state.task_type + ",now(),'" + this.state.expected_end_date + "',now());\r\nSELECT * FROM rb_project_task_details WHERE pt_id=" + _taskDetail.pt_id + " ORDER BY ptd_id DESC LIMIT 1;","The task has been refered");
		//console.log(this.state);
	}

// Open Camera to Take Photo or Record Video
openCamera = async (mode) => {
    try {
      const constraints = mode === "video" ? { video: true, audio: true } : { video: true };
      const stream = await navigator.mediaDevices.getUserMedia(constraints);
      const video = document.createElement("video");
      video.srcObject = stream;
      video.autoplay = true;
	  video.width	=	window.innerWidth - 100;

      const captureButton = document.createElement("button");
      captureButton.innerText = mode === "video" ? "Record" : "Capture";
	  document.getElementById('preview').appendChild(video);
	  document.getElementById('preview').appendChild(captureButton);
      //document.body.appendChild(video);
      //document.body.appendChild(captureButton);

      if (mode === "photo") {
        captureButton.addEventListener("click", (e) => {
          const canvas = document.createElement("canvas");
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
          stream.getTracks().forEach((track) => track.stop());

          const jpgDataUrl = canvas.toDataURL("image/jpeg", 0.6);
		  this.setState({image : jpgDataUrl});
		  document.getElementById('preview').removeChild(video);
		  document.getElementById('preview').removeChild(captureButton);
		  //document.body.removeChild(video);
          //document.body.removeChild(captureButton);
        });
      } else {
        const mediaRecorder = new MediaRecorder(stream);
        const chunks = [];
        captureButton.innerText = "Start Recording";

        captureButton.addEventListener("click", () => {
          if (mediaRecorder.state === "inactive") {
            mediaRecorder.start();
            captureButton.innerText = "Stop Recording";
          } else {
            mediaRecorder.stop();
            captureButton.innerText = "Record";
          }
        });

        mediaRecorder.ondataavailable = (event) => chunks.push(event.data);
        mediaRecorder.onstop = () => {
          const videoBlob = new Blob(chunks, { type: "video/mp4" });
		  this.setState({video : URL.createObjectURL(videoBlob), videoBlob : videoBlob});
          stream.getTracks().forEach((track) => track.stop());
		  document.getElementById('preview').removeChild(video);
		  document.getElementById('preview').removeChild(captureButton);
		  this.setState({preview : false});
          //document.body.removeChild(video);
          //document.body.removeChild(captureButton);
        };
      }
    } catch (error) {
      console.error("Error accessing camera:", error);
    }
  };
  // Start Voice Recording
  startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mediaRecorder = new MediaRecorder(stream);
      const chunks = [];

      mediaRecorder.start();
      const stopButton = document.createElement("button");
      stopButton.innerText = "Stop Recording";
	  document.getElementById('preview').appendChild(stopButton);
	  //document.body.appendChild(stopButton);

      mediaRecorder.ondataavailable = (event) => chunks.push(event.data);
      mediaRecorder.onstop = () => {
        const audioBlob = new Blob(chunks, { type: "audio/mp3" });
		this.setState({audio : URL.createObjectURL(audioBlob), audioBlob : audioBlob});
        //setAudio(URL.createObjectURL(audioBlob));
        stream.getTracks().forEach((track) => track.stop());
		document.getElementById('preview').removeChild(stopButton);
		this.setState({preview : false});
        //document.body.removeChild(stopButton);
      };

      stopButton.addEventListener("click", () => mediaRecorder.stop());
    } catch (error) {
      console.error("Error accessing microphone:", error);
    }
  };
/*
  handlePaste = async (event) => {
    const items = event.clipboardData.items;
    for (let item of items) {
      if (item.type.indexOf("image") === 0) {
        const blob = item.getAsFile();
		this.setState({image : URL.createObjectURL(blob)});
      }
    }
  };
  */
  handlePaste = (event) => {
    const items = event.clipboardData.items;
    for (let item of items) {
        if (item.type.indexOf("image") === 0) {
            const blob = item.getAsFile();
            const reader = new FileReader();
            
            reader.onload = () => {
                this.setState({ image: reader.result }); // Store base64 image in state
            };

            reader.readAsDataURL(blob); // Convert image to base64
        }
    }
};

  fileUpload =(mode) =>{
		if(this.state.image || this.state.video || this.state.audio){
			const _BACKEND_URL_ = 'https://node.renobuilding.ca:3001';
			const parent = this.state.taskFolder;
			const formData = new FormData();
			var file;
			if (this.state.image) 
				file = new File([Buffer.from(this.state.image.split(',')[1], 'base64')], "task_image.jpg", { type: "image/jpeg" });
			if (this.state.video) 
				file = new File([this.state.videoBlob], "task_video.mp4", { type: "video/mp4" });
			if (this.state.audio) 
				file = new File([this.state.audioBlob], "task_audio.mp3", { type: "audio/mp3" });
	
			formData.append('myfile', file);
		
			//fetch(_BACKEND_URL_ + '/file?project=' + this.state.projects.prj_folder_id, {
			fetch(_BACKEND_URL_ + '/file?project=' + parent, {
					method: 'POST',
			body: formData
			})
			.then(response => response.json())
			.then(data => {
				this.addNotification(data.data.name + ' File(s) Uploaded');
				this.resetStates();
				//this.addNotification(' File(s) Uploaded');
				//window.location.reload();	
			})
			.catch(error => {
				console.error(error)
			});	
		}
	}

	findTasksFolder = (_parent) => {
		let requestOptions = {
			method: 'GET',
			headers: {
				'Authorization':'Basic ' + Base64.btoa('sizotech:IsKfs$m$SZV#4Eprtj7zSPbO')
			}
		};
		fetch("https://node.renobuilding.ca:3001" + '/search?fullText=Tasks&parent=' + _parent + '&mimeType=application/vnd.google-apps.folder', requestOptions)
		.then(response => {
		  return Promise.all([response.json(),response])
		})
		.then(([responseData,response]) => {
			if(responseData.length>0){
				//console.log(responseData.filter(d=>!d.trashed)[0].id)
				this.setState({tasksFolder: responseData.filter(d=>!d.trashed)[0].id});
			}else{
				(new Drive()).createFolder(_parent, "Tasks").then(data=>{this.setState({folder: responseData.filter(data)}); });
			}
		})
		.catch(error => {
			console.error('Error:', error);
		})			
}

	render(){
		return (
			<div onPaste={this.handlePaste} >
			<Row >
				<Col xl={12} lg={12} md={12}>
					<Card>
						<CardHeader>8CO Task</CardHeader>
						<CardBody>
						<Form>
							<FormGroup row >
								<Col sm={12} >
								<ButtonGroup className="mr-3 mb-3">
									<Button color={this.state.board_type==0?"primary":"light"} onClick={(e)=>{this.setState({board_type:0});}} >Internal</Button>
									<Button color={this.state.board_type==1?"primary":"light"} onClick={(e)=>{this.setState({board_type:1});}} >External</Button>
								</ButtonGroup>
								</Col>
							</FormGroup>
							<FormGroup row >
								<Label for="project" sm={12}>Board</Label>
								<Col sm={12} >
									{this.state.board_type==0?
									<ComboBox onChange={(e)=>{this.setState({project : e.target.value.split(',')[0], board: e.target.value.split(',')[1], folder: e.target.value.split(',')[2]}); this.findTasksFolder(e.target.value.split(',')[2]); }} table="rb_projects" valueField="prj_id,prj_code,prj_folder_id" displayField="prj_code,prj_title" filterField="prj_status" filterValue={"23' AND prj_code IN (SELECT distinct rb_type_caption FROM rb_types WHERE rb_type='task_type' AND rb_type_caption <> '') AND (prj_code IN (SELECT bm_board FROM rb_board_members WHERE bm_person=" + this.state.sender_id + ")) AND 'x'='x"} defaultValue={this.state.project+','+this.state.board+','+this.state.folder} orderby="prj_code"  />
									:
									<ComboBox onChange={(e)=>{this.setState({project : e.target.value.split(',')[0], board: e.target.value.split(',')[1], folder: e.target.value.split(',')[2]}); this.findTasksFolder(e.target.value.split(',')[2]); }} table="rb_projects" valueField="prj_id,prj_code,prj_folder_id" displayField="prj_code,prj_title" filterField="prj_status" filterValue={"9' AND prj_department IN (SELECT rb_type_no FROM rb_types WHERE rb_type='prj_department' AND rb_type_type_id=1 AND (rb_type_type_no>0 OR rb_type_type_no=-1)) AND 'x'='x"} defaultValue={this.state.project+','+this.state.board+','+this.state.folder} orderby="prj_code"  />
									}
								</Col>
							</FormGroup> 
							
							<FormGroup row >
								<Label for="task_type" sm={12}>Task Type</Label>
								<Col sm={12} >
									{this.state.board_type==0?
										<ComboBox onChange={(e)=>{this.setState({task_type : e.target.value}) }} table="rb_types" valueField="rb_type_no" displayField="rb_type_desc" filterField="rb_type" filterValue={"task_type' AND rb_type_caption='" + this.state.board + "' AND 'x'='x"} orderby="rb_type_desc" defaultValue={this.state.task_type} />
									:
										<ComboBox onChange={(e)=>{this.setState({task_type : e.target.value}) }} table="rb_types" valueField="rb_type_no" displayField="rb_type_desc" filterField="rb_type" filterValue={"task_type' /*AND (rb_type_caption='' OR rb_type_caption is null)*/ AND 'x'='x"} orderby="rb_type_desc" defaultValue={this.state.task_type} />
									}
								</Col>
							</FormGroup>
							<FormGroup row >
								<Label for="receiver_id" sm={12}>Receiver</Label>
								<Col sm={12} >
									<ComboBox id="receiver_id" onChange={(e)=>{this.setState({receiver_id	:	e.target.value.split(',')[0], receiver_email : e.target.value.split(',')[1]}); console.log(e.target.value.split(',')[1])}} table="rb_person" valueField="person_id,email" displayField="name,lastname" filterField="person_type" filterValue={"8' AND (person_id IN (SELECT bm_person FROM rb_board_members WHERE bm_board=" + this.state.board + ")) AND user_expire_date>now() AND 'x'='x"} defaultValue={this.state.receiver_id} orderby="name" />
								</Col>
							</FormGroup>
							<FormGroup row className={'d-none'} >
								<Label for="company_id" sm={12}>Company</Label>
								<Col sm={12} >
									<ComboBox id="company_id" onChange={(e)=>{ this.setState({company_id : e.target.value}); }} table="rb_types" valueField="rb_type_no" displayField="rb_type_no,rb_type_desc" filterField="rb_type" filterValue="prj_department" defaultValue={ this.state.company_id} order="rb_type_no" />
								</Col>
							</FormGroup>
							<FormGroup row >
								<Label for="task" sm={12}>TASK 
									<img onClick={this.handleVoiceInput} src={iconVoice} height={25} className='float-right' />
									<ButtonGroup className='float-right'>
										<Button color={this.state.recognitionLang === 'fa-IR' ? 'primary' : 'light'} onClick={() => this.setState({ recognitionLang: 'fa-IR' })}>فارسی</Button>
										<Button color={this.state.recognitionLang === 'en-US' ? 'primary' : 'light'} onClick={() => this.setState({ recognitionLang: 'en-US' })}>English</Button>
									</ButtonGroup>

								</Label>
								<Col sm={12} >
									<Input
										type="textarea"
										name="task"
										id="task"
										placeholder=""
										onChange={(e)=>{e.persist(); this.setState({task	:	e.target.value})}}
										value={this.state.task}
									/>
								</Col>
							</FormGroup>
							<FormGroup row>
							{!(this.state.image || this.state.video || this.state.audio) && (<>
									<Col>
										<img onClick={() => {this.openCamera("photo"); this.setState({preview:true}) }} src={iconCamera} height={25} className='float-right' />
									</Col>
									<Col>
										<img onClick={() => {this.openCamera("videos"); this.setState({preview : true});}} src={iconVideo} height={25} className='float-right' />
									</Col>
									<Col>
										<img onClick={()=>{this.startRecording(); this.setState({preview:true});}} src={iconMicrophone} height={25} className='float-right' />
									</Col>
								</>)}
								{(this.state.image || this.state.video || this.state.audio) && (<><Col><a onClick={()=>{this.setState({preview : true});}} >Task has an attachment</a></Col></>)}
							</FormGroup>
							<FormGroup row>
								<Col>
									<Button onClick={(e)=>{e.persist(); this.resetStates();}} >Clear</Button>
									<Button onClick={this.onSubmitHandler} className='ml-1' >Assign</Button>
									{this.state.inProgress && <img className='ml-1' src={iconIsProgressing} height={25}/>}
								</Col>
							</FormGroup>
						</Form>
						</CardBody>
					</Card>
				</Col>
				<Modal isOpen={this.state.preview} >
					<ModalHeader>
						<Row>
							<Col>
								<h6>Preview</h6>
							</Col>
							<Col>
							</Col>
							<Col>
								<Button className="float-right" color="primary" onClick={(e) => { this.setState({ preview: false }) }} >X</Button>{' '}
							</Col>
						</Row>
					</ModalHeader>
					<ModalBody>
						<Row>
							<Col>
								{this.state.image && (
									<div>
										<img src={this.state.image} alt="Compressed Preview" style={{ maxWidth: "100%" }} />
									</div>
								)}

								{this.state.video && (
									<div>
									<video controls style={{ maxWidth: "100%" }}>
										<source src={this.state.video} type="video/mp4" />
									</video>
									</div>
								)}

								{this.state.audio && (
									<div>
									<audio controls>
										<source src={this.state.audio} type="audio/mp3" />
									</audio>
									</div>
								)}
								<div id='preview'></div>
							</Col>
						</Row>
					</ModalBody>
				</Modal>
				<NotificationSystem ref={this.notificationSystem} style={NOTIFICATION_SYSTEM_STYLE} />
			</Row>
			</div>
				);
	}
}

export default QuickFormTask;